/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
export enum FileExtension {
  'pdf' = 'pdf',
  'jpg' = 'jpg',
  'jpeg' = 'jpeg',
  'png' = 'png',
  'tiff' = 'tiff',
  'xml' = 'xml',
  'p7m' = 'p7m',
  'eml' = 'eml',
  'txt' = 'txt',
  'html' = 'html',
  'zip' = 'zip',
  'xls' = 'xls'
}
